import React, { useEffect, useRef } from 'react';
import { Routes, Route, Outlet, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import MainContent from './components/MainContent';
import JoinPage from './components/JoinPage';
import SquadronsPage from './components/SquadronsPage';
import SquadronPage from './components/SquadronPage';
import WatchPage from './components/WatchPage';

// GA4 SPA pageviews. The gtag('config') in index.html fires the page_view for
// the initial load; React Router client navigations don't reload the page, so
// we send a page_view on each subsequent location change. Skips the first render
// (already counted by config) and the static pre-render pass.
const RouteTracker = () => {
  const location = useLocation();
  const first = useRef(true);
  useEffect(() => {
    if (typeof window === 'undefined' || window.__PRERENDER__) return;
    if (first.current) { first.current = false; return; }
    // Defer a tick so the routed page's useSeo effect has updated document.title.
    const t = setTimeout(() => {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'page_view', {
          page_location: window.location.href,
          page_path: location.pathname + location.search,
          page_title: document.title,
        });
      }
    }, 0);
    return () => clearTimeout(t);
  }, [location]);
  return null;
};

// Reset scroll to the top on client-side route changes. Without this, React
// Router preserves the previous scroll position, so navigating from deep in the
// long home page (the Squadrons section sits near the bottom) into a shorter
// squadron page leaves you clamped at the bottom. Skip when the URL carries a
// hash so in-page anchors (/#squadrons, /#about-us) still work.
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

// Shared shell: header + footer wrap every route.
const Layout = () => (
  <div className="bg-gray-100 min-h-screen">
    <Header />
    <Outlet />
    <Footer />
  </div>
);

const App = () => {
  return (
    <>
      <ScrollToTop />
      <RouteTracker />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<MainContent />} />
          <Route path="/join-dcs-squadron" element={<JoinPage />} />
          <Route path="/squadrons" element={<SquadronsPage />} />
          <Route path="/squadrons/:slug" element={<SquadronPage />} />
          <Route path="/watch" element={<WatchPage />} />
        </Route>
      </Routes>
    </>
  );
};

export default App;
